import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function ThemeDarkWhiteIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M8 14A6 6 0 0 1 8 2m0 12A6 6 0 0 0 8 2m0 12V2m0 4 3.1-3.1M8 9.533l4.913-4.913M8 13.067l5.9-5.9" /></svg>
  );
}

export default ThemeDarkWhiteIcon;
